import React, { useState } from 'react';
import cocktailImg from '../images/cocktail.jpg';
import floral from '../images/floral.png';
import Modal from './ModalMenu';
import { Link, useLocation, useHistory } from 'react-router-dom';
import dinnerMenu from '../images/dinnerMenu.jpg';
import brunchMenu from '../images/brunchMenu.jpg';

import {
  Paragraph,
  AboutBlock,
  Container,
  TextBlock,
  MenuBlock,
  ImageBlock,
  Frame,
  Image,
  MenuTitle,
  Floral,
  Small,
  Article,
} from './styles/AboutnMenu';

function AboutnMenu() {
  let location = useLocation();
  const history = useHistory();

  function handleClick(menuname, menu) {
    history.push(`/menu/${menuname}`, { background: location, menu: menu });
  }

  return (
    <Container>
      <TextBlock>
        <AboutBlock>
          <h1 id="about">About</h1>
          <Paragraph>
            La Boite en Bois is a quaint and romantic French restaurant located
            in the heart of the Upper West Side since 1985. Just off Columbus
            Avenue, it is tucked away in a beautiful brownstone. With its
            romantic ambience, you will feel as though you are in the
            countryside of France.
            <hr />A favorite of patrons of Lincoln Center, our experienced and
            attentive staff will be sure to provide you with an unforgettable
            experience. Family owned and operated.
          </Paragraph>
          <Paragraph>
            <Article
              target="_blank"
              href="https://www.nytimes.com/2015/06/28/travel/a-food-tour-of-seinfelds-new-york.html"
            >
              As seen on Seinfeld
            </Article>
          </Paragraph>
          <Paragraph>
            <Article
              target="_blank"
              href="https://www.nbcnewyork.com/entertainment/the-scene/new-york-live/making-moves-with-tiler-peck/2242681/"
            >
              New York Live feature where NYC Ballet's Tiler Peck chooses La
              Boite as one of her favorite places in the city
            </Article>
          </Paragraph>
        </AboutBlock>
        <MenuBlock id="menu">
          <h1 style={{ marginBottom: '4rem' }}>Menu</h1>
          <Floral src={floral} alt="frame" />
          <ul>
            <li>
              <a
                href="https://www.opentable.com/la-boite-en-bois"
                target="_blank"
                rel="noopener noreferrer"
              >
                <MenuTitle>View menus on OpenTable</MenuTitle>
              </a>
            </li>
            {/* <li onClick={() => handleClick("lunchMenu", lunchMenu)}>
              <MenuTitle>Lunch</MenuTitle> <span> week days until 3 p.m </span>
            </li>
            <li onClick={() => handleClick("prixFixe", prixFixe)}>
              <MenuTitle>Prix fixe</MenuTitle>
              <span> from 4 a.m to 8 p.m </span>
            </li>
            <li onClick={() => handleClick("dinnerMenu", dinnerMenu)}>
              <MenuTitle>Dinner</MenuTitle> <span> after 8 p.m </span>
            </li>
            <li onClick={() => handleClick("brunchMenu", brunchMenu)}>
              <MenuTitle>Brunch</MenuTitle>
              <span> {"Sat & Sun until 3 p.m"}</span>
            </li> */}
          </ul>
          <Small>Menu items may change due to availability</Small>
        </MenuBlock>
      </TextBlock>
      <ImageBlock>
        <Frame />
        <Image>
          <img src={cocktailImg} alt="cocktail" />
        </Image>
      </ImageBlock>
    </Container>
  );
}

export default AboutnMenu;
